import { PaletteOptions } from "@mui/material";
/**
 * Light palette
 */
const palette: PaletteOptions = {
  primary: {
    main: "#000000",
    light: "#000000",
    dark: "#000000",
  },
  secondary: {
    main: "#00d8bc",
    light: "#00d8bc",
    dark: "#00d8bc",
  },
  label: {
    main: "#000",
  },
  common: {
    black: "rgba(0, 0, 0, 0.87)",
  },
  extends: {
    lightGray: {
      main: "#F6F6F7",
    },
    paperGray: {
      main: "#f0f0f0",
    },
  },
};

export default palette;
